export class InvoiceConstants {
  static OBJECTTYPEID = '$invoicing_invoice_id';
}
